module.exports = __webpack_public_path__ + "d99f3fe142da903b7c09f89e2316bbe2.png";